<app-modal-frame
  [headerText]="isEdit ? CONSTANTS.EDIT_HEADER : CONSTANTS.ADD_HEADER"
  [leftButton]="{
    type: BUTTON_TYPES.CANCEL_BUTTON,
  }"
  [rightButton]="{
    text: isEdit ? CONSTANTS.SAVE : CONSTANTS.ADD_ROUTE,
    disable: this.addRouteForm.invalid || this.addRouteForm.pristine,
    type: BUTTON_TYPES.TEXT_BUTTON,
  }"
  (emitLeftClick)="onClose()"
  (emitRightClick)="onSubmit()"
  (emitExit)="onClose()"
>
  <form [formGroup]="addRouteForm" class="card-content">
    <!--Route Details Section-->
    <ion-row class="section-wrapper">
      {{ CONSTANTS.SECTION_HEADERS.ROUTE_DETAILS }}
    </ion-row>
    <ion-row>
      <!--Route-->
      <ion-col size="2">
        <app-form-text-field
          [labelText]="CONSTANTS.ROUTE_DETAILS_HEADERS.ROUTE"
          [maxLength]="3"
          [form]="addRouteForm"
          [control]="FORM_CONTROL.ROUTE.formControlName"
          [regexType]="SpecialCharacters.ALPHABET_NUMBER"
          [placeholderText]="FORM_CONTROL.ROUTE.defaultValue"
          [autoCapitalizeCharacters]="true"
        ></app-form-text-field>
      </ion-col>

      <!--LBT-->
      <ion-col size="3">
        <app-form-time-picker
          [headerText]="CONSTANTS.ROUTE_DETAILS_HEADERS.LBT"
          [defaultStartTime]="FORM_CONTROL.LBT.defaultValue"
          [form]="addRouteForm"
          [control]="FORM_CONTROL.LBT.formControlName"
          (inputChangedEvent)="dataChanged()"
        ></app-form-time-picker>
      </ion-col>

      <!--Optimize-->
      <ion-col class="form-group optional-form-group" size="2">
        <app-form-select
          [label]="CONSTANTS.ROUTE_DETAILS_HEADERS.OPTIMIZE"
          [options]="DROP_DOWN_VALUES.imageDropdownOptions"
          [formControlName]="FORM_CONTROL.OPTIMIZE.formControlName"
          [isSearchable]="false"
        >
        </app-form-select>
      </ion-col>

      <!--Vehicle-->
      <ion-col size="2">
        <app-form-select
          [label]="CONSTANTS.ROUTE_DETAILS_HEADERS.VEHICLE"
          [options]="VEHICLE_VALUES"
          [formControlName]="FORM_CONTROL.VEHICLE.formControlName"
        >
        </app-form-select>
      </ion-col>

      <ion-col size="3">
        <div class="empty-header"></div>
      </ion-col>
    </ion-row>

    <!---------------------------->

    <br />

    <!-- Address Section-->
    <ion-row class="section-wrapper">
      {{ CONSTANTS.SECTION_HEADERS.ADDRESS }}
    </ion-row>

    <ion-row>
      <!-- Location Start/End-->
      <ion-col size="2">
        <app-form-select
          [label]="CONSTANTS.ADDRESS_HEADERS.LOCATION_START_END"
          [options]="DROP_DOWN_VALUES.facilityDropdownOptions"
          [formControlName]="FORM_CONTROL.LOCATION_START_END.formControlName"
          [isSearchable]="false"
          (update)="updateLocation()"
        ></app-form-select>
      </ion-col>
    </ion-row>

    <ion-row>
      <!-- Address Start/End-->
      <ion-col size="8">
        <app-form-text-field
          [labelText]="CONSTANTS.ADDRESS_HEADERS.ADDRESS_START_END"
          [maxLength]="1000"
          [form]="addRouteForm"
          [control]="FORM_CONTROL.ADDRESS_START_END.formControlName"
          [regexType]="SpecialCharacters.ADDRESS"
          [placeholderText]="FORM_CONTROL.ADDRESS_START_END.defaultValue"
          [autoCapitalizeCharacters]="true"
          [readonly]="isAddressFieldsReadOnly"
        ></app-form-text-field>
      </ion-col>
    </ion-row>

    <ion-row>
      <!-- Latitude Start/End-->
      <ion-col size="4">
        <app-form-text-field
          [labelText]="CONSTANTS.ADDRESS_HEADERS.LATITUDE_START_END"
          [form]="addRouteForm"
          [control]="FORM_CONTROL.LAT_START_END.formControlName"
          [invalidPatternMessage]="ERROR_CONSTANTS.INVALID_LATITUDE"
          [placeholderText]="FORM_CONTROL.LAT_START_END.defaultValue"
          [readonly]="isAddressFieldsReadOnly"
        ></app-form-text-field>
      </ion-col>

      <!-- Longitude Start/End-->
      <ion-col size="4">
        <app-form-text-field
          [labelText]="CONSTANTS.ADDRESS_HEADERS.LONGITUDE_START_END"
          [form]="addRouteForm"
          [control]="FORM_CONTROL.LONG_START_END.formControlName"
          [invalidPatternMessage]="ERROR_CONSTANTS.INVALID_LONGITUDE"
          [placeholderText]="FORM_CONTROL.LONG_START_END.defaultValue"
          [readonly]="isAddressFieldsReadOnly"
        ></app-form-text-field>
      </ion-col>
    </ion-row>
    <!---------------------------->

    <br />
    <br />

    <!-- Break Details Section-->
    <ion-row class="section-wrapper">
      {{ CONSTANTS.SECTION_HEADERS.BREAK }}
    </ion-row>

    <ion-row>
      <ion-col>
        <ion-row class="break-row">
          <!--Break-->
          <ion-col size="hasBreak ? 1:4">
            <app-form-select
              [label]="CONSTANTS.BREAK_HEADERS.BREAK"
              [options]="DROP_DOWN_VALUES.imageDropdownOptions"
              [formControlName]="FORM_CONTROL.BREAK.formControlName"
              (update)="onBreakSelectChange()"
            ></app-form-select>
          </ion-col>

          <!--Break Start-->
          @if (hasBreak) {
            <ion-col size="2">
              <app-form-text-field
                [labelText]="CONSTANTS.BREAK_HEADERS.BREAK_START"
                [maxLength]="1"
                [form]="addRouteForm"
                [regexType]="SpecialCharacters.NUMBER_ONLY"
                [control]="FORM_CONTROL.BREAK_START.formControlName"
                [placeholderText]="FORM_CONTROL.BREAK_START.defaultValue"
              ></app-form-text-field>
            </ion-col>
          }

          <!--Break End-->
          @if (hasBreak) {
            <ion-col size="2">
              <app-form-text-field
                [labelText]="CONSTANTS.BREAK_HEADERS.BREAK_END"
                [maxLength]="1"
                [form]="addRouteForm"
                [regexType]="SpecialCharacters.NUMBER_ONLY"
                [control]="FORM_CONTROL.BREAK_END.formControlName"
                [placeholderText]="FORM_CONTROL.BREAK_END.defaultValue"
              ></app-form-text-field>
            </ion-col>
          }

          <!--Duration-->
          @if (hasBreak) {
            <ion-col size="2">
              <app-form-text-field
                [labelText]="CONSTANTS.BREAK_HEADERS.DURATION"
                [maxLength]="3"
                [form]="addRouteForm"
                [control]="FORM_CONTROL.DURATION.formControlName"
                [regexType]="SpecialCharacters.NUMBER_ONLY"
                [placeholderText]="FORM_CONTROL.DURATION.defaultValue"
              ></app-form-text-field>
            </ion-col>
          }

          <!--Del Wait Time-->
          <ion-col size="hasBreak ? 2:4">
            <app-form-text-field
              [labelText]="CONSTANTS.BREAK_HEADERS.DEL_WAIT_TIME"
              [maxLength]="2"
              [form]="addRouteForm"
              [control]="FORM_CONTROL.DEL_WAIT_TIME.formControlName"
              [regexType]="SpecialCharacters.NUMBER_ONLY"
              [placeholderText]="FORM_CONTROL.DEL_WAIT_TIME.defaultValue"
            ></app-form-text-field>
          </ion-col>

          <!--PU Wait Time-->
          <ion-col size="hasBreak ? 2:4">
            <app-form-text-field
              [labelText]="CONSTANTS.BREAK_HEADERS.PU_WAIT_TIME"
              [maxLength]="2"
              [form]="addRouteForm"
              [control]="FORM_CONTROL.PU_WAIT_TIME.formControlName"
              [regexType]="SpecialCharacters.NUMBER_ONLY"
              [placeholderText]="FORM_CONTROL.PU_WAIT_TIME.defaultValue"
            ></app-form-text-field>
          </ion-col>
        </ion-row>
        @if (hasInvalidBreakTime) {
          <ion-row>
            <ion-col offset="2">
              <label class="validation-message">
                {{ CONSTANTS.INVALID_BREAK }}
              </label>
            </ion-col>
          </ion-row>
        }
      </ion-col>
    </ion-row>
    <!---------------------------->
  </form>
</app-modal-frame>
